module.exports = __webpack_public_path__ + "media/images/instagram_white-4e2bc68c10b51800a49eed680ace89b5.png";